import createReactComponent from '../createReactComponent';
export default createReactComponent('framer', 'Framer', [["path",{"d":"M12 15.6V21l-6.5-5.4zM5.5 3l13 12.6h-13V9.3h13V3z","key":"svg-0"}]]);